import {t} from 'react-switch-lang';

export const appModuleIdsOptions = [
  {value: 1, label: t('departments.riskModule')},
  {value: 2, label: t('departments.revisionModule')},
  {value: 3, label: t('departments.externalizationModule')}
]